import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { CardNumberElement } from 'react-stripe-elements';
import TextField from '@material-ui/core/TextField';
import StripeInput from './StripeInput';

class StripeCardNumberField extends PureComponent {
  render() {
    const {
      InputLabelProps,
      InputProps,
      fullWidth = true,
      error,
      margin = 'normal',
      ...other
    } = this.props;

    return (
      <TextField
        fullWidth={fullWidth}
        margin={margin}
        error={error}
        variant="outlined"
        InputLabelProps={{
          ...InputLabelProps,
          shrink: true,
        }}
        InputProps={{
          ...InputProps,
          inputProps: {
            component: CardNumberElement,
          },
          inputComponent: StripeInput,
        }}
        {...other}
      />
    );
  }
}

StripeCardNumberField.propTypes = {
  InputLabelProps: PropTypes.object,
  InputProps: PropTypes.object,
  fullWidth: PropTypes.bool,
  error: PropTypes.bool,
  margin: PropTypes.string,
};

StripeCardNumberField.defaultProps = {
  InputLabelProps: {},
  InputProps: {},
  fullWidth: true,
  error: false,
  margin: 'normal',
};

export default StripeCardNumberField;
